// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes circular-animation-4f73bab1{to{stroke-dashoffset:0}}.last-year-entry[data-v-4f73bab1]{padding:20px 50px;text-align:right}@media only screen and (max-width:1024px){.last-year-entry[data-v-4f73bab1]{padding:20px}}.btn-cta[data-v-4f73bab1]{border-bottom:1px solid #000;font-size:14px}@media(-moz-touch-enabled:0),(hover:hover),(pointer:fine){.btn-cta[data-v-4f73bab1]:hover{border-color:#008779}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
